import { NextPage } from 'next';
import ProjectLayout from '@layouts/project-layout/project-layout';
import WebNeobankingComponent from '@components/projects/web-neobanking/web-neobanking';
import { ProjectProps } from '@models/project.interface';

const WebNeobanking: NextPage<ProjectProps> = (project) => {
  return (
    <ProjectLayout project={project}>
      <WebNeobankingComponent breadcrumbsText={project.project.breadcrumbsText} />
    </ProjectLayout>
  );
};

export default WebNeobanking;
export { getServerSideProps } from '@layouts/project-layout/project-layout';
